import { render, staticRenderFns } from "./QRRegistrationTable.vue?vue&type=template&id=578d821b"
import script from "./QRRegistrationTable.vue?vue&type=script&lang=js"
export * from "./QRRegistrationTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports